import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from "recharts";

const DashboardChart = ({ title, type, data, xAxisDataKey, bars, dropdownOptions, activeDropdown, onDropdownChange, exportButtons, pieData, pieColors }) => {
  return (
    <div className="dashboard-chart-card">
      <div className="dashboard-chart-header">
        <h3 className="dashboard-chart-title">{title}</h3>
        {dropdownOptions && dropdownOptions.length > 0 && (
          <select
            className="dashboard-chart-dropdown"
            value={activeDropdown}
            onChange={(e) => onDropdownChange && onDropdownChange(e.target.value)}
          >
            {dropdownOptions.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        )}
      </div>
      <div className="dashboard-chart-content">
        {type === "bar" && (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={data}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey={xAxisDataKey} />
              <YAxis />
              <Tooltip />
              <Legend />
              {bars.map((bar, index) => (
                <Bar key={index} dataKey={bar.dataKey} fill={bar.fill} name={bar.name} />
              ))}
            </BarChart>
          </ResponsiveContainer>
        )}
        {type === "horizontalBar" && (
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={data} layout="vertical" margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis type="number" />
              <YAxis dataKey={xAxisDataKey} type="category" width={100} />
              <Tooltip />
              {bars.map((bar, index) => (
                <Bar key={index} dataKey={bar.dataKey}>
                  {data.map((entry, idx) => (
                    <Cell key={`cell-${idx}`} fill={bar.colors ? bar.colors[idx % bar.colors.length] : bar.fill} />
                  ))}
                </Bar>
              ))}
            </BarChart>
          </ResponsiveContainer>
        )}
        {type === "pie" && pieData && (
          <ResponsiveContainer width="100%" height={300}>
            <PieChart>
              <Pie
                data={pieData}
                cx="50%"
                cy="50%"
                labelLine={false}
                label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                outerRadius={80}
                fill="#8884d8"
                dataKey="value"
              >
                {pieData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={pieColors[index % pieColors.length]} />
                ))}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        )}
      </div>
      {exportButtons && (
        <div className="dashboard-chart-actions">
          <button className="dashboard-export-btn dashboard-export-pdf">Export as PDF</button>
          <button className="dashboard-export-btn dashboard-export-csv">Export as CSV</button>
        </div>
      )}
    </div>
  );
};

export default DashboardChart;

